(function () {
  'use strict';

  function initBelanttiDesktopMega() {
    var root = document.querySelector('[data-bel-dhm]');
    if (!root || root.dataset.belDhmReady === 'true') return;
    root.dataset.belDhmReady = 'true';

    var triggers = root.querySelectorAll('[data-bel-menu-trigger]');
    var panels = root.querySelectorAll('[data-bel-panel]');
    var megaWrap = root.querySelector('[data-bel-mega-wrap]');
    var searchToggle = root.querySelector('[data-bel-search-toggle]');
    var searchPanel = root.querySelector('[data-bel-search-panel]');
    var searchClose = root.querySelector('[data-bel-search-close]');
    var searchInput = root.querySelector('[data-bel-search-input]');
    var closeTimer = null;

    function normalisePath(value) {
      if (!value) return '/';
      var path = value.split('?')[0].split('#')[0];
      if (path.length > 1 && path.charAt(path.length - 1) === '/') path = path.slice(0, -1);
      return path || '/';
    }

    function linkPath(link) {
      if (!link || !link.href) return '';
      try {
        return normalisePath(new URL(link.href, window.location.origin).pathname);
      } catch (error) {
        return normalisePath(link.getAttribute('href') || '');
      }
    }

    function cleanMenuLabel(element) {
      if (!element) return '';
      var explicit = element.getAttribute('data-bel-title');
      if (explicit) return explicit.replace(/\s+/g, ' ').trim().slice(0, 120);

      var copy = element.querySelector('.bel-dhm-link-copy, .bel-dhm-feature-card-title, .bel-dhm-guide-copy');
      var value = copy ? copy.textContent : element.textContent;
      return (value || '').replace(/\s+/g, ' ').trim().slice(0, 120);
    }

    function publishMenuInteraction(details) {
      var payload = {
        menu_surface: 'desktop_mega',
        interaction_type: details.interactionType || 'link_click',
        menu_level: details.menuLevel || 'submenu',
        menu_section: details.menuSection || '',
        menu_label: details.menuLabel || '',
        destination: details.destination || '',
        source_path: normalisePath(window.location.pathname),
        is_current_category: Boolean(details.isCurrentCategory),
        menu_version: root.getAttribute('data-bel-dhm-version') || '',
        item_position: details.itemPosition || null,
        destination_type: details.destinationType || '',
        brand_or_category: details.brandOrCategory || ''
      };

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'belantti_menu_interaction',
        menu_surface: payload.menu_surface,
        interaction_type: payload.interaction_type,
        menu_level: payload.menu_level,
        menu_section: payload.menu_section,
        menu_label: payload.menu_label,
        destination: payload.destination,
        source_path: payload.source_path,
        is_current_category: payload.is_current_category,
        menu_version: payload.menu_version,
        item_position: payload.item_position,
        destination_type: payload.destination_type,
        brand_or_category: payload.brand_or_category
      });

      try {
        window.dispatchEvent(new CustomEvent('belantti:menu_interaction', { detail: payload }));
      } catch (error) {}

    }

    function productCollectionHandles() {
      return (root.getAttribute('data-bel-product-collections') || '')
        .split(',')
        .map(function (handle) { return handle.trim(); })
        .filter(Boolean);
    }

    function panelMatchesProduct(panelName, handles) {
      var panel = panelFor(panelName);
      if (!panel || !handles.length) return false;
      var links = panel.querySelectorAll('a[href^="/collections/"]');

      for (var i = 0; i < links.length; i += 1) {
        var path = linkPath(links[i]);
        var handle = path.indexOf('/collections/') === 0 ? path.slice('/collections/'.length) : '';
        if (handle && handles.indexOf(handle) !== -1) return true;
      }

      return false;
    }

    function findCurrentPanel() {
      var currentPath = normalisePath(window.location.pathname);
      var exactTrigger = null;

      triggers.forEach(function (trigger) {
        if (!exactTrigger && linkPath(trigger) === currentPath) exactTrigger = trigger;
      });

      if (exactTrigger) {
        return {
          name: exactTrigger.getAttribute('data-panel'),
          exact: true
        };
      }

      var handles = productCollectionHandles();

      if (currentPath.indexOf('/products/') === 0 && handles.length) {
        if (handles.indexOf('collagen') !== -1 || handles.indexOf('benjamin-button') !== -1) {
          return { name: 'shop', exact: false };
        }

        var productPriority = [
          'korean',
          'skin',
          'hair',
          'makeup',
          'nails',
          'grooming',
          'fragrance',
          'gifts',
          'brands',
          'newin',
          'shop'
        ];

        for (var p = 0; p < productPriority.length; p += 1) {
          if (panelMatchesProduct(productPriority[p], handles)) {
            return { name: productPriority[p], exact: false };
          }
        }
      }

      for (var i = 0; i < panels.length; i += 1) {
        var links = panels[i].querySelectorAll('a[href]');
        for (var j = 0; j < links.length; j += 1) {
          if (linkPath(links[j]) === currentPath) {
            return {
              name: panels[i].getAttribute('data-bel-panel'),
              exact: false
            };
          }
        }
      }

      return null;
    }

    function markCurrentContext() {
      triggers.forEach(function (trigger) {
        trigger.classList.remove('is-current');
        trigger.removeAttribute('aria-current');
      });

      var current = findCurrentPanel();
      if (!current || !current.name) return;

      var currentTrigger = root.querySelector('[data-bel-menu-trigger][data-panel="' + current.name + '"]');
      if (!currentTrigger) return;

      currentTrigger.classList.add('is-current');
      currentTrigger.setAttribute('aria-current', current.exact ? 'page' : 'true');
    }

    function panelFor(name) {
      return root.querySelector('[data-bel-panel="' + name + '"]');
    }

    function syncMenuA11y(activeName, isOpen) {
      triggers.forEach(function (trigger) {
        var name = trigger.getAttribute('data-panel');
        var panel = panelFor(name);
        var triggerId = 'bel-dhm-trigger-' + name;
        var panelId = 'bel-dhm-panel-' + name;
        var expanded = Boolean(isOpen && activeName === name);

        trigger.id = triggerId;
        trigger.setAttribute('aria-controls', panelId);
        trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');

        if (panel) {
          panel.id = panelId;
          panel.setAttribute('aria-labelledby', triggerId);
          panel.setAttribute('aria-hidden', expanded ? 'false' : 'true');
        }
      });
    }

    function loadFeature(url, featureName, initName) {
      if (!url) return;
      if (typeof window[initName] === 'function') {
        window[initName](root);
        return;
      }

      var existing = document.querySelector('script[data-bel-feature="' + featureName + '"]');
      if (existing) {
        existing.addEventListener('load', function () {
          if (typeof window[initName] === 'function') window[initName](root);
        }, { once: true });
        return;
      }

      var script = document.createElement('script');
      script.src = url;
      script.async = true;
      script.setAttribute('data-bel-feature', featureName);
      script.addEventListener('load', function () {
        if (typeof window[initName] === 'function') window[initName](root);
      }, { once: true });
      document.head.appendChild(script);
    }

    function closeSearch(returnFocus) {
      if (!searchPanel || !searchToggle) return;
      searchPanel.classList.remove('is-open');
      searchPanel.setAttribute('aria-hidden', 'true');
      searchToggle.setAttribute('aria-expanded', 'false');
      if (returnFocus) searchToggle.focus();
    }

    function closeMega(returnFocus) {
      clearTimeout(closeTimer);
      var activeTrigger = root.querySelector('[data-bel-menu-trigger].is-active');
      root.classList.remove('is-mega-open');

      triggers.forEach(function (trigger) {
        trigger.classList.remove('is-active');
      });

      panels.forEach(function (panel) {
        panel.classList.remove('is-active');
      });

      syncMenuA11y(null, false);
      if (returnFocus && activeTrigger) activeTrigger.focus();
    }

    function setActive(panelName) {
      clearTimeout(closeTimer);
      closeSearch(false);

      triggers.forEach(function (trigger) {
        trigger.classList.toggle('is-active', trigger.getAttribute('data-panel') === panelName);
      });

      panels.forEach(function (panel) {
        panel.classList.toggle('is-active', panel.getAttribute('data-bel-panel') === panelName);
      });

      root.classList.add('is-mega-open');
      syncMenuA11y(panelName, true);

      if (panelName === 'brands') {
        loadFeature(root.getAttribute('data-bel-brands-script'), 'brands', 'BelanttiDesktopBrandsInit');
      }
    }

    function scheduleClose() {
      clearTimeout(closeTimer);
      closeTimer = window.setTimeout(function () {
        closeMega(false);
      }, 180);
    }

    function openSearch() {
      if (!searchPanel || !searchToggle) return;
      closeMega(false);
      searchPanel.classList.add('is-open');
      searchPanel.setAttribute('aria-hidden', 'false');
      searchToggle.setAttribute('aria-expanded', 'true');
      loadFeature(root.getAttribute('data-bel-search-script'), 'search', 'BelanttiDesktopSearchInit');
      window.setTimeout(function () {
        if (searchInput) searchInput.focus();
      }, 40);
    }

    syncMenuA11y(null, false);
    markCurrentContext();

    if (searchPanel && searchToggle) {
      searchPanel.id = 'bel-dhm-search-panel';
      searchPanel.setAttribute('aria-hidden', 'true');
      searchToggle.setAttribute('aria-controls', 'bel-dhm-search-panel');
      searchToggle.setAttribute('aria-expanded', 'false');
    }

    triggers.forEach(function (trigger) {
      trigger.addEventListener('mouseenter', function () {
        setActive(trigger.getAttribute('data-panel'));
      });

      trigger.addEventListener('focus', function () {
        setActive(trigger.getAttribute('data-panel'));
      });

      trigger.addEventListener('click', function (event) {
        var panelName = trigger.getAttribute('data-panel');
        var isOpen = root.classList.contains('is-mega-open');
        var isCurrentPanel = trigger.classList.contains('is-active');
        var willNavigate = Boolean(isOpen && isCurrentPanel);

        publishMenuInteraction({
          interactionType: willNavigate ? 'top_level_navigate' : 'top_level_open',
          menuLevel: 'top',
          menuSection: panelName,
          menuLabel: cleanMenuLabel(trigger),
          destination: linkPath(trigger),
          isCurrentCategory: trigger.classList.contains('is-current')
        });

        if (!willNavigate) {
          event.preventDefault();
          setActive(panelName);
        }
      });

      trigger.addEventListener('keydown', function (event) {
        if (event.key !== 'ArrowDown') return;
        event.preventDefault();
        var panelName = trigger.getAttribute('data-panel');
        setActive(panelName);
        var panel = panelFor(panelName);
        var firstFocusable = panel ? panel.querySelector('a[href], button:not([disabled]), input:not([disabled])') : null;
        if (firstFocusable) firstFocusable.focus();
      });
    });

    root.addEventListener('mouseenter', function () {
      clearTimeout(closeTimer);
    });
    root.addEventListener('mouseleave', scheduleClose);

    if (megaWrap) {
      megaWrap.addEventListener('mouseenter', function () {
        clearTimeout(closeTimer);
      });
      megaWrap.addEventListener('mouseleave', scheduleClose);

      megaWrap.addEventListener('click', function (event) {
        var target = event.target;
        var link = target && target.closest ? target.closest('a[href]') : null;
        if (!link || !megaWrap.contains(link)) return;

        var panel = link.closest('[data-bel-panel]');
        var section = panel ? panel.getAttribute('data-bel-panel') : '';

        publishMenuInteraction({
          interactionType: 'link_click',
          menuLevel: 'submenu',
          menuSection: section,
          menuLabel: cleanMenuLabel(link),
          destination: linkPath(link),
          itemPosition: link.getAttribute('data-bel-item-position') || Array.prototype.indexOf.call(link.parentNode ? link.parentNode.children : [], link) + 1,
          destinationType: linkPath(link).indexOf('/collections/') === 0 ? 'collection' : (linkPath(link).indexOf('/pages/') === 0 ? 'page' : 'other'),
          brandOrCategory: link.getAttribute('data-bel-brand-name') ? 'brand' : 'category',
          isCurrentCategory: Boolean(
            section &&
            root.querySelector('[data-bel-menu-trigger][data-panel="' + section + '"].is-current')
          )
        });
      });
    }

    if (searchToggle) {
      searchToggle.addEventListener('click', function () {
        if (searchPanel && searchPanel.classList.contains('is-open')) closeSearch(true);
        else openSearch();
      });
    }

    if (searchClose) {
      searchClose.addEventListener('click', function () {
        closeSearch(true);
      });
    }

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;

      if (searchPanel && searchPanel.classList.contains('is-open')) {
        closeSearch(true);
        return;
      }

      if (root.classList.contains('is-mega-open')) closeMega(true);
    });

    root.addEventListener('focusout', function () {
      window.setTimeout(function () {
        if (!root.contains(document.activeElement) && root.classList.contains('is-mega-open')) {
          closeMega(false);
        }
      }, 0);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBelanttiDesktopMega, { once: true });
  } else {
    initBelanttiDesktopMega();
  }

  document.addEventListener('shopify:section:load', initBelanttiDesktopMega);
})();
